import Swiper from "swiper"
import "swiper/css"

class WorksImagesHandler {
  constructor(root = document) {
    this.sliders = Array.from(root.querySelectorAll(".works__images--slider"))
    this.sliders.forEach(slider => this.init(slider))
  }

  init(slider) {
    new Swiper(slider, {
      slidesPerView: 1.15,
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        // Two per view with the same 20px gap matches the two-image grid
        // exactly, so a slider image is the same size as a static one.
        768: {slidesPerView: 2},
      },
    })
  }
}

export default WorksImagesHandler
